import { Fragment, Slot, VNode } from 'vue';

export function VSlotUnwrap(slot?: Slot): VNode[] {
    if (!slot) return [];

    const flatten = (nodes: VNode[]): VNode[] => nodes.flatMap((node) => {
        if (!node) return [];
        if (node.type === Fragment && Array.isArray(node.children)) {
            return flatten(node.children as VNode[]);
        }
        return [node];
    });

    return flatten(slot());
}
